import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserDataService } from './userData.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { PresenceService } from './presence.service';
import { RrhhSessionService } from '../../pages/05-rrhh/services/rrhh-session.service';
import { RrhhAccessService } from '../../pages/05-rrhh/services/rrhh-access.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly rrhhSessionService = inject(RrhhSessionService);
  private readonly rrhhAccessService = inject(RrhhAccessService);

  constructor(
    private afAuth: AngularFireAuth,
    private presenceService: PresenceService
  ) {}

  get authState$(): Observable<any> {
    return this.afAuth.authState;
  }

  async login(email: string, password: string): Promise<any> {
    const result = await this.afAuth.signInWithEmailAndPassword(email, password);
    const user = result.user;
    if (user?.email) {
      const hasAccess = await this.rrhhAccessService.hasRrhhAccess(user.uid);
      if (hasAccess) {
        const userName = user.displayName || user.email.split('@')[0] || 'Usuario';
        this.rrhhSessionService.logLogin(user.uid, userName, user.email);
      }
    }
    return result;
  }

  async logOut(): Promise<any> {
    const user = await this.afAuth.currentUser;
    if (user?.email) {
      const hasAccess = await this.rrhhAccessService.hasRrhhAccess(user.uid);
      if (hasAccess) {
        const userName = user.displayName || user.email.split('@')[0] || 'Usuario';
        this.rrhhSessionService.logLogout(user.uid, userName, user.email);
      }
    }
    this.afAuth.signOut().then(() => {
      window.location.href = '';
    });
  }

  recoberyPassword(email:any): Promise<any> {
    return this.afAuth.sendPasswordResetEmail(email);
  }
}
